import { useCallback, useContext } from 'react';
import { MerchantContext } from './merchant-context';
import { MerchantInfo } from '../../interfaces/MerchantInfo';

export const useMerchant = () => {
  const {
    merchantData,
    setMerchantData,
    isNemuru,
    setIsNemuru,
    isApp,
    setIsApp,
    isPostDataMessages,
    setIsPostDataMessages,
  } = useContext(MerchantContext);

  const createMerchant = useCallback(
    (newMerchant: MerchantInfo | null | undefined): void => {
      setMerchantData(newMerchant);
    },
    [setMerchantData]
  );

  const createNemuru = useCallback(
    (newIsNemuru: boolean | null | undefined): void => {
      setIsNemuru(newIsNemuru);
    },
    [setIsNemuru]
  );

  const createIsApp = useCallback(
    (newIsApp: boolean): void => {
      setIsApp(newIsApp);
    },
    [setIsApp]
  );

  const createDataMessages = useCallback(
    (newIsDataMessages: boolean): void => {
      setIsPostDataMessages(newIsDataMessages);
    },
    [setIsPostDataMessages]
  );

  const deleteMerchant = useCallback(() => {
    setMerchantData(null);
  }, [setMerchantData]);

  const deleteNemuru = useCallback(() => {
    setIsNemuru(null);
  }, [setIsNemuru]);

  const deleteIsApp = useCallback(() => {
    setIsApp(false);
  }, [setIsApp]);

  const deleteDataMessages = useCallback(() => {
    setIsPostDataMessages(false);
  }, [setIsPostDataMessages]);

  return {
    merchantData,
    createMerchant,
    deleteMerchant,
    isNemuru,
    createNemuru,
    deleteNemuru,
    isApp,
    createIsApp,
    deleteIsApp,
    isPostDataMessages,
    createDataMessages,
    deleteDataMessages,
  };
};
